import React, { useEffect, useState } from 'react';
import HTTP from '../../../config/axios';
import DataTable from 'react-data-table-component';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash, faUndo } from "@fortawesome/free-solid-svg-icons";
import { Button, Row, Col } from 'react-bootstrap';
import CustomModal from '../../common/CustomModal';
import SimpleToast from '../../common/Toast';
import InputGroupField from '../../form/InputGroupField';
import { useForm } from 'react-hook-form';
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import Checkbox from '../../form/Checkbox';
import { encryptLocalStorage } from '../../../config/utils/storage';


const SpecificationTable: React.FC<any> = ({ newSpecification, editModalDetails, addEditCount }) => {
    const [specificationData, setSpecificationData] = useState([])
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [perPage, setPerPage] = useState(10)
    const [currentPage, setCurrentPage] = useState(1)
    const [isLoading, setIsLoading] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState<number | null>(null);
    const [toast, setToast] = useState({ open: false, header: '', message: '', variant: '' })
    const [totalRows, setTotalRows] = useState(0);
    const [searchText, setSearchText] = useState('')
    const [sortDetails, setSortDetails] = useState({ sortColumn: '', sortDirection: '' })
    const [model, setModel] = useState('all')
    const [removedIds, setRemovedIds] = useState<any>([])
    const [isSuperAdmin, setIsSuperAdmin] = useState(false);
    const { control, reset, watch } = useForm();
    const archivedSpecification = watch('archived')
    const [openActivateModal, setOpenActivateModal] = useState(false)
    const currentSearchText = watch('search');
    const [deletModalContent, setDeleteModalContent] = useState<React.JSX.Element>(<p>Are you sure you want to delete?</p>)

    //Custom Style for the data table
    const customStyles = {
        headCells: {
            style: {
                fontSize: "15px",
                fontWeight: "700"
            },
        },
    };

    const getTypeDefinition = (id: number) => {
        const types: any = {
            1: 'Dimensions',
            2: 'Engine',
            3: 'Transmission',
            4: 'Suspension system',
            5: 'Steering',
            6: 'Brake system',
            7: 'Performance',
            8: 'Fuel',
            9: 'Tyre',
        }
        return types[id]
    }

    //Column Declaraion for the data table
    const columns: any = [
        {
            name: 'Name',
            selector: (row: { name: string; }) => row.name,
            sortable: true,
            keyName: 'name'
        },
        {
            name: 'Type',
            selector: (row: { type: number; }) => getTypeDefinition(row.type),
            sortable: true,
            keyName: 'unit'
        },
        {
            name: 'Unit',
            selector: (row: { unit: string; }) => row.unit,
            sortable: true,
            keyName: 'unit'
        },
        {
            name: 'Sort Order',
            selector: (row: { sort: number; }) => row.sort,
            sortable: false,
            keyName: 'sort'
        },
        {
            name: 'Action',
            cell: (row: any) => (
                <div>
                    {!archivedSpecification ? <><Button variant={isSuperAdmin ? "success" : "secondary"} size="sm" className="me-3" onClick={() => isSuperAdmin && editSpecification(row)} title="Edit info" disabled={!isSuperAdmin}>
                        <FontAwesomeIcon icon={faPen} />
                    </Button> <Button variant={isSuperAdmin ? "primary" : "secondary"} size="sm" className="me-3" onClick={() => isSuperAdmin && handleDeleteClick(row.id)} title="Remove specification" disabled={!isSuperAdmin}>
                            <FontAwesomeIcon icon={faTrash} />  </Button></> :
                        <Button variant={isSuperAdmin ? "success" : "secondary"} size="sm" className="me-3" onClick={() => isSuperAdmin && editSpecification(row)} title="Make active" disabled={!isSuperAdmin}>
                            <FontAwesomeIcon icon={faUndo} />
                        </Button>
                    }
                </div>
            ),
            center: "true",
        }
    ];

    useEffect(()=>{
        const user = encryptLocalStorage.getItem('userInfo')
        setIsSuperAdmin(user?.roleWeight >= 90);
    },[])

    //Fetching the intial data for the data table
    useEffect(() => {
        const getAllSpecification = async () => {
            try {
                setIsLoading(true);
                interface QueryParams {
                    searchText?: string;
                    sortDetails?: {};
                    status?: number;
                }
                const params: QueryParams = {};
                params.searchText = currentSearchText
                if (sortDetails) {
                    params.sortDetails = JSON.stringify(sortDetails)
                }
                params.status = archivedSpecification ? 0 : 1;
                const response = await HTTP.get(`/api/admin/specification/fetch-all/${currentPage}/${perPage}`, { params });
                const { data: { status, data, msg, error, totalRecords } } = response;
                setSpecificationData(data.rows);
                setTotalRows(data.count);
            } catch (error: any) {
                if (error.response?.status === 401) {
                    setToast({ open: true, header: 'Access Denied', message: 'You do not have permission to access this resource', variant: 'danger' })
                } else {
                    setToast({ open: true, header: 'Failed', message: 'Something went wrong', variant: 'danger' })
                }
            } finally {
                setIsLoading(false);
            }
        }
        getAllSpecification()
    }, [addEditCount, currentPage, perPage, currentSearchText, sortDetails, model, removedIds, archivedSpecification]);

    //Invokng the edit modal for editing the model
    const editSpecification = (model: any) => {
        editModalDetails(model)
    }

    //Handling the page change
    const handlePageChange = (page: any) => {
        setCurrentPage(page)
    }

    //handling the no.of rows changing
    const handlePerRowsChange = async (newPerPage: number, page: number) => {
        setPerPage(newPerPage)
    };

    //handling Delete of models
    const handleDeleteClick = async (id: number) => {
        try {
            //Api to fetch total vehicles Affected 
            const response = await HTTP.get(`/api/admin/specification/vehicleCount/${id}`, {  });
            const { data: { status, vehicleCount } } = response;
            
            if(vehicleCount > 0){
                setDeleteModalContent(<>
                                        <p>Deleting this will affect <strong>{vehicleCount}</strong> vehicle configurations that depend on it.</p>
                                        <p>Are you sure you want to proceed with deleting this specification?</p>
                                      </>)
            } else{
                setDeleteModalContent(<p>Are you sure you want to delete?</p>)
            }

            setSelectedRecord(id);
            setIsOpenModal(true)
        } catch (error: any) {
            if (error.response?.status === 401) {
                setToast({ open: true, header: 'Access Denied', message: 'You do not have permission to access this resource', variant: 'danger' })
            } else {
                setToast({ open: true, header: 'Failed', message: 'Something went wrong', variant: 'danger' })
            }
        }
    }

    const handleActivateClick = (id: number) => {
        setSelectedRecord(id);
        setOpenActivateModal(true)
    }

    const handleCancelClick = () => {
        setSelectedRecord(null);
        setIsOpenModal(false)
        setOpenActivateModal(false)
    }

    const handleDelete = async () => {
        try {
            setIsOpenModal(false)
            const response = await HTTP.patch(`/api/admin/specification/remove/${selectedRecord}`);
            const { data: { status, data, totalCount, message, type, error } } = response
            if (status == 1) {
                setRemovedIds([...removedIds, selectedRecord])
                setToast({ open: true, header: 'Success', message: 'Specification deleted successfully', variant: 'success' })
            } else if (status == 0 && type == "assigned") {
                setToast({ open: true, header: 'Failed', message: message, variant: 'danger' })
            } else {
                setToast({ open: true, header: 'Failed', message: 'Something went wrong', variant: 'danger' })
            }
        } catch (error: any) {
            if (error.response?.status === 401) {
                setToast({ open: true, header: 'Access Denied', message: 'You do not have permission to perform this action', variant: 'danger' })
            } else {
                setToast({ open: true, header: 'Failed', message: 'Something went wrong', variant: 'danger' })
            }
        }
    }

    const handleRecover = async () => {
        try {
            setOpenActivateModal(false)
            setIsLoading(true);

            const response = await HTTP.patch(`/api/admin/specification/recover/${selectedRecord}`);
            const { data: { status, data, totalCount, msg, error } } = response
            if (status == 1) {
                setRemovedIds([...removedIds, selectedRecord])
                setToast({ open: true, header: 'Success', message: 'Specification recovered successfully', variant: 'success' })
            } else {
                setToast({ open: true, header: 'Failed', message: 'Something went wrong', variant: 'danger' })
            }
        } catch (error: any) {
            if (error.response?.status === 401) {
                setToast({ open: true, header: 'Access Denied', message: 'You do not have permission to perform this action', variant: 'danger' })
            } else {
                setToast({ open: true, header: 'Failed', message: 'Something went wrong', variant: 'danger' })
            }
        } finally {
            setIsLoading(false);
        }
    }


    //Handling the sort
    const handleSort = (column: any, sortDirection: any) => {
        const columnDetails = { sortColumn: column.keyName, sortDirection: sortDirection }
        setSortDetails(columnDetails)
        //getAllModels({page:1,limit,'makeId',columnDetails})
    }

    return (<>
        <Row className='mb-1'>
            <div className="d-flex">
                <div className="p-2 flex-grow-1"><h2 className="mb-0 text-gray">Vehicle specification</h2></div>
                <div className="p-2 mt-2"><Checkbox name="archived" control={control} label="Show removed specifications"
                    classList="" /></div>
                <div className="p-2">
                    <Button variant={isSuperAdmin ? "success" : "secondary"} onClick={newSpecification} disabled={!isSuperAdmin}>
                        Add specification
                    </Button>
                </div>
                <div className="p-2"><InputGroupField name="search" placeholder="Search" label="" control={control} addOn={faSearch} /></div>
            </div>
        </Row>

        <DataTable
            columns={columns}
            data={specificationData}
            striped={true}
            onSort={handleSort}
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            highlightOnHover={true}
            customStyles={customStyles}
        />

        <CustomModal isOpen={isOpenModal} title="Delete Specification"
            component={deletModalContent}
            closeModal={setIsOpenModal} buttonList={<>
                <Button variant="secondary" onClick={handleCancelClick}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleDelete}>
                    Confirm
                </Button></>} />
        <CustomModal isOpen={openActivateModal} title="Recover specification"
            component={<p>Are you sure you want to recover?</p>}
            closeModal={setOpenActivateModal} buttonList={<>
                <Button variant="secondary" onClick={handleCancelClick}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleRecover}>
                    Confirm
                </Button></>} />

        <SimpleToast show={toast.open} header={toast.header}
            message={toast.message} variant={toast.variant}
            onClose={() => setToast({ ...toast, open: false })} />


    </>)
}

export default SpecificationTable;